// @ts-strict-ignore
import { EventHistoryItem } from '@fc-core/notifications/models/event-history-item';
import {
  Component,
  computed,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { Store } from '@ngrx/store';
import { getEmployeeById } from '@fc-store/selectors';
import { AvatarModule } from '@fc-shared/ui/avatar/avatar.module';

@Component({
  selector: 'fc-event-item',
  imports: [MatRipple, RouterLink, IconComponent, AvatarModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ` <div
    class="
      flex items-center justify-between
      py-12 px-20
      gap-8
      sm:gap-16
      border-b border-secondary-100
      cursor-pointer
      hover:bg-secondary-50
    "
    matRipple
    [routerLink]="event().message.link.fullUrl"
    (click)="markAsRead.emit(event().id)"
  >
    <div class="relative flex items-center justify-center size-48 shrink-0">
      @if (event().message.image) {
        <img
          [src]="event().message.image"
          class="size-48 rounded-full object-cover"
          alt="event-image"
        />
      } @else {
        @switch (event().message.type) {
          @case ('event') {
            <fc-icon
              icon="icon-empty_state_vehicle"
              [size]="48"
              color="secondary200"
            ></fc-icon>
          }

          @case ('chat') {
            <fc-entity-avatar
              type="employee"
              [entity]="employee()"
              [size]="48"
            ></fc-entity-avatar>
          }

          @case ('task') {
            <div
              class="size-48 rounded-xl bg-secondary-100 flex items-center justify-center"
            >
              <fc-icon
                icon="icon-tasks-bold"
                [size]="24"
                color="secondary600"
              />
            </div>
          }

          @default {
            <div
              class="size-48 rounded-xl bg-secondary-100 flex items-center justify-center"
            >
              <fc-icon
                icon="icon-notification-bold"
                [size]="24"
                color="secondary600"
              ></fc-icon>
            </div>
          }
        }
      }
    </div>
    <div class="flex flex-col gap-4">
      <div class="text-md text-grey-900 font-medium">
        {{ event().message.title }}
      </div>
      <div class="text-grey-600">
        {{ event().message.body }}
      </div>
    </div>

    <div class="flex flex-col justify-between items-end ml-auto gap-8">
      <div class="text-sm text-secondary-600">
        {{ event().readAt }}
      </div>
      @if (!event().read) {
        <div class="bg-primary-600 size-10 rounded-full"></div>
      }
    </div>
  </div>`,
})
export class EventItemComponent {
  event = input<EventHistoryItem>();
  store = inject(Store);
  employee = computed(() => {
    if (this.event().message.type === 'chat') {
      return this.store.selectSignal(
        getEmployeeById(this.event().message.context.author.id),
      )();
    }
  });
  markAsRead = output<string>();
}
